import { addMethod, string, TestContext } from 'yup'

import { Message } from 'yup/lib/types'
import { DateValidationOptions } from 'src/@types/yup'
import { isDateValid, isFutureDate, isBeforeLongAgo, isMonthYearValid } from 'src/utils/date'

// All yup custom methods should be defined here
// To work correctly with typescript, we need to
// define the types in `src/@types/yup.ts

addMethod(string, "validDate", function (errorMessage: Message, options?: DateValidationOptions) {
  return this.test(`testValidDate`, errorMessage, function (value) {
    const { path, createError } = this
    const allowFuture = options && options.allowFuture
    if(!value) {
      return createError({ path, message: errorMessage })
    }
    if (!isDateValid(value)) {
      return createError({ path, message: errorMessage })
    }
    if (isBeforeLongAgo(value)) {
      return createError({ path, message: errorMessage })
    }
    if (!allowFuture && isFutureDate(value)) {
      return createError({ path, message: errorMessage })
    }
    return true
  })
})


addMethod(string, "validMonthYear", function(errorMessage: Message, options?: DateValidationOptions) {
  return this.test('testMonthYearFormat', errorMessage, function(value) {
    const { path, createError } = this
    const allowFuture = options && options.allowFuture
    if(!value) {
      return createError({ path, message: errorMessage })
    }
    if(!isMonthYearValid(value)) {
      return createError({ path, message: errorMessage })
    }
    if(isBeforeLongAgo(value, true)) {
      return createError({ path, message: errorMessage })
    }
    if(!allowFuture && isFutureDate(value, true)) {
      return createError({ path, message: errorMessage })
    }
    return true
  })
})

interface AddressComponent {
  longName?: string;
  shortName?: string;
  types?: Array<string>;
}

export const validateAddressComponent = (value: string | undefined, context: TestContext<AddressComponent>) => {
  const { parent } = context

  if(parent?.types && parent?.types?.includes('postal_code')) {
    if(!value || value.length < 5) return false
    return true
  }

  if(parent?.types && (
    parent?.types?.includes('locality') ||
    parent?.types?.includes('route') ||
    parent?.types?.includes('state')
  )) {
    if(!value) return false
    return true
  }

  return true
}

export const validateAddressComponentsArray = (value: any) => {
  if(!value) return false
  const typesArr = value.map((item: any) => item?.types?.[0] ?? '').flat()
  if(
    !typesArr.includes('postal_code') ||
    !typesArr.includes('locality') ||
    !typesArr.includes('route') ||
    !typesArr.includes('state')
  ) return false
  return true
}

export const isValidUrl = (url:any) => {
  if(url === undefined || url === '' || url == null)
  {
    return true;
  }

  const pattern = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?(\/.*)*$/
  let res =  pattern.test(url);
  return res;
};